import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import addPv from '@/plugins/addPv/addPv';
import appShareInfo from '@/plugins/ShareInfo/appShareInfo';
import wxShareInfo from '@/plugins/ShareInfo/wxShareInfo';
import vConsole from 'vconsole';
Vue.config.productionTip = false;

const devConsole =
  process.env.VUE_APP_NO_CONSOLE === 'true' ? 'no-console' : new vConsole();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// Vue.mixin(mixins);
Vue.use(addPv);
Vue.use(appShareInfo);
Vue.use(wxShareInfo);
// Vue.use(test);
